// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.qARy9h_ILOPDgk0wSr3P {
  /* height: calc(100vh - 150px); */
  margin: 15px 30px 0 30px;
}

.jOI5zQrVaR4IAj_0PvNc {
  overflow-y: auto;
}

.bHprQ331XLsX0_TKOSdl {
  height: calc(100vh - 125px);
  overflow-y: auto;
  margin: 0px 20px 0 80px;
  /* background-color: #f4f7fc; */
}

.bHprQ331XLsX0_TKOSdl::-webkit-scrollbar {
  width: 3px;
}

.bHprQ331XLsX0_TKOSdl::-webkit-scrollbar-thumb {
  background-color: gray;
}

.XpqTf9j8yfpiDWAJEfWT::-webkit-scrollbar {
  width: 5px;
}

.XpqTf9j8yfpiDWAJEfWT::-webkit-scrollbar-thumb {
  background-color: gray;
}

.eT8g2og6xK6oQPXAF_0L {
  text-align: left;
  margin-left: 10px;
  margin-top: 15px;
}

.hQUdASqCirctAyXP6r5A {
  font-weight: 500;
}

.gUK9NCBkOYc7KfFfCeo0 {
  /* height: 100%;
    float: left;
    width: 100%;*/
  height: calc(100vh - 150px);
  overflow: auto;
  text-align: justify;
  grid-row-gap: 20px;
  row-gap: 20px;
  border-radius: 10px;
  box-shadow: 0px 1px 2px 1px #969696;
  background-color: white;
  padding-top: 10px;
}

.gUK9NCBkOYc7KfFfCeo0 h3 {
  margin-left: 20px;
  padding-top: 15px;
}

.XpqTf9j8yfpiDWAJEfWT h3 {
  text-align: left;
  margin-left: 10px;
  padding-top: 15px;
  background-color: white;
  width: 59%;
}

.XpqTf9j8yfpiDWAJEfWT {
  box-shadow: 0px 1px 2px 1px #969696;
  width: 100%;
  float: right;
  min-height: 300px;
  background-color: white;
  border-radius: 10px;
  overflow-y: auto;
  max-height: 100%;
  height: 100%;
}

.K7pAJxQwYimLOlyn7dgl {
  position: relative;
  padding-bottom: 10px;
  margin-left: 10px;
}

.ryCf5lfKLLSPe4Oi0Ult h1 {
  overflow-y: auto;
  float: left;
  position: fixed;
  background-color: white;
  display: flex;
  padding-bottom: 0px;
  padding-right: 100%;
}

.K7pAJxQwYimLOlyn7dgl span {
  position: absolute;
  left: 50%;
  font-weight: 600;
}

.jOI5zQrVaR4IAj_0PvNc {
  padding-bottom: 30px;
}

.K7pAJxQwYimLOlyn7dgl {
  margin-left: 20px;
  padding-top: 15px;
}

@media only screen and (max-width: 778px) {
  .qARy9h_ILOPDgk0wSr3P {
    margin: 0px 0px 0 0px;
  }
  .K7pAJxQwYimLOlyn7dgl {
    margin-left: 10px;
  }
}`, "",{"version":3,"sources":["webpack://./components/Insidedetails/Projectdetails.module.css"],"names":[],"mappings":"AAAA;EACE,iCAAA;EACA,wBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE,2BAAA;EACA,gBAAA;EACA,uBAAA;EACA,+BAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,UAAA;AACF;;AAEA;EACE,sBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,gBAAA;AACF;;AAEA;EACE,gBAAA;AACF;;AAEA;EACE;;iBAAA;EAGA,2BAAA;EACA,cAAA;EACA,mBAAA;EACA,kBAAA;EACA,aAAA;EACA,mBAAA;EACA,mCAAA;EACA,uBAAA;EACA,iBAAA;AACF;;AAEA;EACE,iBAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,iBAAA;EACA,iBAAA;EACA,uBAAA;EACA,UAAA;AACF;;AAEA;EACE,mCAAA;EACA,WAAA;EACA,YAAA;EACA,iBAAA;EACA,uBAAA;EACA,mBAAA;EACA,gBAAA;EACA,gBAAA;EACA,YAAA;AACF;;AAEA;EACE,kBAAA;EACA,oBAAA;EACA,iBAAA;AACF;;AAEA;EACE,gBAAA;EACA,WAAA;EACA,eAAA;EACA,uBAAA;EACA,aAAA;EACA,mBAAA;EACA,mBAAA;AACF;;AAEA;EACE,kBAAA;EACA,SAAA;EACA,gBAAA;AACF;;AAEA;EACE,oBAAA;AACF;;AAEA;EACE,iBAAA;EACA,iBAAA;AACF;;AAEA;EACE;IACE,qBAAA;EACF;EACA;IACE,iBAAA;EACF;AACF","sourcesContent":[".alerts {\n  /* height: calc(100vh - 150px); */\n  margin: 15px 30px 0 30px;\n}\n\n.scrollclass {\n  overflow-y: auto;\n}\n\n.noti {\n  height: calc(100vh - 125px);\n  overflow-y: auto;\n  margin: 0px 20px 0 80px;\n  /* background-color: #f4f7fc; */\n}\n\n.noti::-webkit-scrollbar {\n  width: 3px;\n}\n\n.noti::-webkit-scrollbar-thumb {\n  background-color: gray;\n}\n\n.rightDiv::-webkit-scrollbar {\n  width: 5px;\n}\n\n.rightDiv::-webkit-scrollbar-thumb {\n  background-color: gray;\n}\n\n.alert {\n  text-align: left;\n  margin-left: 10px;\n  margin-top: 15px;\n}\n\n.alertMsg {\n  font-weight: 500;\n}\n\n.leftDiv {\n  /* height: 100%;\n    float: left;\n    width: 100%;*/\n  height: calc(100vh - 150px);\n  overflow: auto;\n  text-align: justify;\n  grid-row-gap: 20px;\n  row-gap: 20px;\n  border-radius: 10px;\n  box-shadow: 0px 1px 2px 1px #969696;\n  background-color: white;\n  padding-top: 10px;\n}\n\n.leftDiv h3 {\n  margin-left: 20px;\n  padding-top: 15px;\n}\n\n.rightDiv h3 {\n  text-align: left;\n  margin-left: 10px;\n  padding-top: 15px;\n  background-color: white;\n  width: 59%;\n}\n\n.rightDiv {\n  box-shadow: 0px 1px 2px 1px #969696;\n  width: 100%;\n  float: right;\n  min-height: 300px;\n  background-color: white;\n  border-radius: 10px;\n  overflow-y: auto;\n  max-height: 100%;\n  height: 100%;\n}\n\n.common {\n  position: relative;\n  padding-bottom: 10px;\n  margin-left: 10px;\n}\n\n.notifications h1 {\n  overflow-y: auto;\n  float: left;\n  position: fixed;\n  background-color: white;\n  display: flex;\n  padding-bottom: 0px;\n  padding-right: 100%;\n}\n\n.common span {\n  position: absolute;\n  left: 50%;\n  font-weight: 600;\n}\n\n.scrollclass {\n  padding-bottom: 30px;\n}\n\n.common {\n  margin-left: 20px;\n  padding-top: 15px;\n}\n\n@media only screen and (max-width: 778px) {\n  .alerts {\n    margin: 0px 0px 0 0px;\n  }\n  .common {\n    margin-left: 10px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"alerts": `qARy9h_ILOPDgk0wSr3P`,
	"scrollclass": `jOI5zQrVaR4IAj_0PvNc`,
	"noti": `bHprQ331XLsX0_TKOSdl`,
	"rightDiv": `XpqTf9j8yfpiDWAJEfWT`,
	"alert": `eT8g2og6xK6oQPXAF_0L`,
	"alertMsg": `hQUdASqCirctAyXP6r5A`,
	"leftDiv": `gUK9NCBkOYc7KfFfCeo0`,
	"common": `K7pAJxQwYimLOlyn7dgl`,
	"notifications": `ryCf5lfKLLSPe4Oi0Ult`
};
export default ___CSS_LOADER_EXPORT___;
